import { NewsModel, NewsFilterModel, LikeModel } from 'src/app/models/News.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryFilterModel, CategoryModel } from 'src/app/models/Category.model';
import { map } from 'rxjs/operators';
import { ApiService } from '../API/api.service';
import { EditorialModel } from 'src/app/models/Editorial.model';
import { hexToCSSFilter, HexToCssConfiguration } from 'hex-to-css-filter';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(
    private readonly api: ApiService,
    public translateService: TranslateService,
  ) {}

  newsUrl = 'news/api/v1/';
  config: HexToCssConfiguration = {
    acceptanceLossPercentage: 0.5,
    maxChecks: 30,
  };

  getNews(filter: NewsFilterModel): Observable<NewsModel[]> {
    return this.api.get(`${this.newsUrl}News`, filter).pipe(
      map((news: any) =>
        news.map((c: NewsModel) => {
          const newsItem = new NewsModel(c);
          if (newsItem.text[this.translateService.currentLang]) {
            const regex = /\[https:\/\/[^ ]+\.mp4\]/g;

            const matches = newsItem.text[this.translateService.currentLang].match(regex);

            if (matches) {
              newsItem.internVideo = matches[0].replace('[', '').replace(']', '');

              newsItem.text[this.translateService.currentLang] = newsItem.text[
                this.translateService.currentLang
              ].replace(matches[0], '');
            }
          }
          return newsItem;
        }),
      ),
    );
  }

  getNewsByCategory(category: string[]): Observable<any> {
    return this.api.get(`${this.newsUrl}News`).pipe(
      map((news: any) =>
        news.map((c: any) => {
          const newsItem = new NewsModel(c);

          if (newsItem.text[this.translateService.currentLang]) {
            const regex = /\[https:\/\/[^ ]+\.mp4\]/g;

            const matches = newsItem.text[this.translateService.currentLang].match(regex);

            if (matches) {
              newsItem.internVideo = matches[0].replace('[', '').replace(']', '');

              newsItem.text[this.translateService.currentLang] = newsItem.text[
                this.translateService.currentLang
              ].replace(matches[0], '');
            }
          }
          return newsItem;
        }),
      ),
    );
  }

  getNewsById(id: string): Observable<any> {
    return this.api.get(`${this.newsUrl}News/${id}`).pipe(
      map(news => {
        const newsItem = new NewsModel(news);
        if (newsItem.text[this.translateService.currentLang]) {
          const regex = /\[https:\/\/[^ ]+\.mp4\]/g;

          const matches = newsItem.text[this.translateService.currentLang].match(regex);

          if (matches) {
            newsItem.internVideo = matches[0].replace('[', '').replace(']', '');

            newsItem.text[this.translateService.currentLang] = newsItem.text[this.translateService.currentLang].replace(
              matches[0],
              '',
            );
          }
        }
        return newsItem;
      }),
    );
  }

  getCategories(filter?: CategoryFilterModel): Observable<CategoryModel[]> {
    return this.api
      .get(`${this.newsUrl}categories`, filter)
      .pipe(map((categories: any) => categories.map((c: CategoryModel) => new CategoryModel(c))));
  }

  getCategoriesById(id: string): Observable<any> {
    return this.api.get(`${this.newsUrl}categories/${id}`).pipe(map(category => category));
  }

  getEditorials(): Observable<EditorialModel[]> {
    return this.api.get(`${this.newsUrl}News/editorials`).pipe(
      map((editorial: any) =>
        editorial.map((e: EditorialModel) => {
          try {
            e.FilterColor = {
              filter: hexToCSSFilter(e.labelColor, this.config).filter.replace(';', ''),
            };
          } catch {
            e.FilterColor = {
              filter: 'invert(100%) sepia(0%) saturate(0%) hue-rotate(127deg) brightness(103%) contrast(101%);',
            };
          }
          return new EditorialModel(e);
        }),
      ),
    );
  }

  getNewsLikes(newsId: string, employeeId: string): Observable<LikeModel> {
    return this.api
      .get(`${this.newsUrl}Likes?NewsId=${newsId}&EmployeeId=${employeeId}`)
      .pipe(map(likes => new LikeModel(likes)));
  }

  like(like: LikeModel): Observable<any> {
    return this.api.post(`${this.newsUrl}Likes`, like);
  }

  unLike(newsId: string, employeeId: string): Observable<any> {
    return this.api.delete(`${this.newsUrl}Likes?userId=${employeeId}&newsId=${newsId}`);
  }

  getCaminhosViews(userId: string): Observable<any> {
    return this.api.get(`${this.newsUrl}CaminhosViews`).pipe(map(caminhos => caminhos));
  }

  updateCaminhosView(userId: string): Observable<any> {
    return this.api.put(`${this.newsUrl}CaminhosViews`, {});
  }
}
